import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../axiosConfig';
import SurveyPageForm from './SurveyPageForm';
import { SurveyPagesProvider, useSurveyPages } from '../../contexts/SurveyPagesContext';
import { Box, Heading, Text, Tabs, TabList, TabPanels, Tab, TabPanel, Card, CardBody, CardHeader } from '@chakra-ui/react';
import InterpretationEditor from './InterpretationEditor';
import QuestionsList from '../questions/QuestionsList';
import { QuestionsProvider } from '../../contexts/QuestionsContext';

const SurveyPageEditContent = () => {
  const { surveyId, pageId } = useParams();
  const { updatePage } = useSurveyPages();
  const [initialData, setInitialData] = useState(null);
  const [surveyName, setSurveyName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSurveyAndPage = async () => {
      try {
        const [surveyResponse, pageResponse] = await Promise.all([
          axios.get(`/surveys/${surveyId}`),
          axios.get(`/surveys/${surveyId}/survey_pages/${pageId}`)
        ]);
        setSurveyName(surveyResponse.data.name);
        setInitialData(pageResponse.data.page);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchSurveyAndPage();
  }, [surveyId, pageId]);

  const handleUpdatePage = async (pageData) => {
    await updatePage(pageId, pageData);
    navigate(`/app/surveys/${surveyId}/pages`);
  };

  return (
    <Box mx="auto" p={6} maxW="container.2xl">
      <Card>
        <CardHeader>
          {initialData ? 
            <Heading as="h2" size="lg">Page: {pageId} - {initialData.name}</Heading>
            : ""
          }
          <Text fontSize="lg" color="gray.500">Survey: {surveyName}</Text>
          
        </CardHeader>
        <CardBody>
          {initialData ? (
            <Tabs variant="enclosed">
              <TabList>
                <Tab>Page Details</Tab>
                <Tab>Questions</Tab>
                <Tab>Interpretation</Tab>
              </TabList>

              <TabPanels>
                <TabPanel>
                  <SurveyPageForm
                    initialData={initialData}
                    onSubmit={handleUpdatePage}
                    onCancel={() => navigate(`/app/surveys/${surveyId}/pages`)}
                  />
                </TabPanel>

                <TabPanel>
                  <QuestionsProvider surveyId={surveyId} surveyPageId={pageId}>
                    <QuestionsList />
                  </QuestionsProvider>
                </TabPanel>

                <TabPanel>
                  <InterpretationEditor surveyPageId={pageId} />
                </TabPanel>
              </TabPanels>
            </Tabs>
          ) : (
            <Text>Loading...</Text>
          )}
        </CardBody>
      </Card>
    </Box>
  );
};

const SurveyPageEdit = () => {
  const { surveyId } = useParams();

  return (
    <SurveyPagesProvider surveyId={surveyId}>
      <SurveyPageEditContent />
    </SurveyPagesProvider>
  );
};

export default SurveyPageEdit;